import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, randomString, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ExpenseSpanningVO, useQueryExpensePage} from "@/service/expense.s";
import {ReviewStatus} from "@/widget/ReviewStatus/ReviewStatus";
import {useAuthInfo} from "@/store/account.c";
import {WriteExpense} from "@/pages/Expense/WriteExpense";
import {Avatar} from "@mui/material";
import {useMemo} from "react";
import {PaginationVO} from "@/model/global";
import {FundPO} from "@/model/finance";
import {ViewExpense} from "@/pages/Expense/ViewExpense";

export const ExpenseListPage = () => {
    const {
        mutate: expensePageMutate,
        data: expensePageData,
        isPending: expensePagePending,
    } = useQueryExpensePage()
    const {id} = useAuthInfo()

    const columns: GridColDef<ExpenseSpanningVO>[] = [
        {
            field: "receiptName", headerName: "账户名称", headerAlign: 'center', align: 'center', minWidth: 120, display: 'flex'
        },
        {
            field: "receiptBank",
            headerName: "收款银行",
            headerAlign: "center",
            align: "center",
            display: "flex",
        },
        {
            field: "receiptAccount",
            headerName: "收款账号",
            headerAlign: "center",
            align: "center",
            display: "flex",
        },
        {
            field: "creator",
            headerName: "支付人",
            headerAlign: "center",
            align: "center",
            rowSpanValueGetter: () => null,
            display: 'flex',
            renderCell: ({row}) => <Avatar {...stringAvatar(row.creator)} />
        },
        {
            field: "name",
            headerName: "款项",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {
            field: "money",
            headerName: "金额",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {
            field: "remark",
            headerName: "摘要",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            display: "flex",
            align: "center",
            renderCell: ({row}) => <ReviewStatus processorIds={row.processorIds} authId={id} auditStatus={row.auditStatus} nodeNames={row.nodeNames}/>,
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            display: "flex",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];
    const expenseSpanning = useMemo(() => {
        const expensePage = expensePageData?.data
        const result = expensePage?.list?.map((item): ExpenseSpanningVO[] => {
            const funds = item?.funds
            return funds.map((k: FundPO): ExpenseSpanningVO => {
                return {...item, _id: randomString(12), ...k}
            })
        })
        const expenseSpanning: PaginationVO<ExpenseSpanningVO> = {...expensePage!, list: result?.flat() || []}
        return expenseSpanning
    }, [expensePageData?.data])

    return (
        <ProTable<ExpenseSpanningVO>
            loading={expensePagePending}
            renderDrawer={{view: <ViewExpense/>, write: <WriteExpense/>}}
            columns={columns}
            rowSpanning={true}
            hover={false}
            checkboxSelection={false}
            rowId={"_id"}
            data={expenseSpanning}
            onSearch={(params) => {
                expensePageMutate(params);
            }}
            drawerProps={{
                view: {
                    hiddenFooter: true,
                    viewBtnCallback: (row: ExpenseSpanningVO) => {
                        return {businessId: row.id, instanceId: row.instanceId, updateForm: <WriteExpense/>}
                    }
                }
            }}
            code={"expense"}
        />
    );
};
